import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    FaHome,
    FaHeart,
    FaHandshake,
    FaEnvelopeOpenText,
    FaArrowRight,
    FaPhone,
    FaEnvelope,
    FaMapMarkerAlt,
    FaWhatsapp,
    FaFacebook,
    FaInstagram,
    FaTwitter,
    FaSearch,
    FaCalendarCheck,
    FaGift,
    FaUsers,
    FaChartLine,
    FaUserPlus,
    FaClock,
    FaCheckCircle,
    FaImages,
    FaLaptop
} from 'react-icons/fa';
import './Error404.css';

const Error404 = () => {
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleMouseMove = (e) => {
            setMousePosition({
                x: (e.clientX / window.innerWidth - 0.5) * 20,
                y: (e.clientY / window.innerHeight - 0.5) * 20
            });
        };

        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <div className="error-page">
            {/* ===== BACKGROUND DECORATIVE ELEMENTS ===== */}
            <div className="error-bg-pattern"></div>
            <div className="error-bg-circle circle-1"></div>
            <div className="error-bg-circle circle-2"></div>
            <div className="error-bg-circle circle-3"></div>

            {/* ===== MAIN CONTENT ===== */}
            <div className="error-content">
                <div className="error-main">
                    {/* 404 Animation */}

                    <div className="error-text-container">
                        <span className="error-badge">Ooh!</span>
                        <h1 className="error-title">Tumefanya Mabadiliko Makubwa</h1>
                        <p className="error-description">
                            Huenda ukurasa Unaoutafuta umehamishwa, Umeondolewa au Inawezekana umeandika Link isiyo sahihi.
                        </p>
                    </div>

                    {/* Search and Action Buttons */}
                    <div className="error-actions">


                        <div className="error-buttons">
                            <Link to="/" className="error-btn-primary">
                                <FaHome className="me-2" />
                                Rudi Mwanzo
                                <FaArrowRight className="ms-2" />
                            </Link>
                            <Link to="/WatoaHuduma" className="error-btn-secondary">
                                <FaHandshake className="me-2" />
                                Watoa Huduma
                            </Link>
                            <Link to="/e_card" className="error-btn-secondary">
                                <FaEnvelopeOpenText className="me-2" />
                                Kadi za Mwaliko
                            </Link>
                        </div>
                    </div>
                </div>

                {/* ===== FEATURES SECTION ===== */}
                <div className="error-features">
                    <div className="error-features-header">
                        <span className="section-subtitle">Huduma Zetu</span>
                        <h2 className="error-features-title">Huduma zime boreshwa zaidi kwenye HarusiOnline</h2>
                        <div className="section-divider"></div>
                        <p className="error-features-subtitle">
                            Tumeboresha  huduma mbalimbali ili kurahisisha Upangaji wako wa shughuli
                        </p>
                    </div>

                    <div className="error-features-grid">
                        {[

                            {
                                icon: FaEnvelopeOpenText,
                                title: " Mialiko ya Kidigitali",
                                description: "Tengeneza na tuma kadi za mwaliko za kidigitali kwa wageni wako kwa urahisi zaidi.",
                                color: "#10b981",
                                link: "/e_card"
                            },
                            {
                                icon: FaHandshake,
                                title: "Watoa Huduma",
                                description: "Pata watoa huduma bora wa ukumbi, chakula, mziki, mapambo na zaidi.",
                                color: "#f59e0b",
                                link: "/WatoaHuduma"
                            },
                            {
                                icon: FaImages,
                                title: "Albamu ya Picha",
                                description: "Weka na shiriki kumbukumbu ya Picha na Matukio.",
                                color: "#ec4899",
                                link: "/login"
                            },
                            {
                                icon: FaChartLine,
                                title: "Ripoti za Fedha",
                                description: "Fuatilia bajeti yako, rekodi matumizi na pata ripoti kamili za fedha.",
                                color: "#06b6d4",
                                link: "/login"
                            },
                            {
                                icon: FaGift,
                                title: "Kukumbushia Michango",
                                description: "Pokea na fuatilia michango ya wageni wako kwa urahisi na kuwashukuru.",
                                color: "#8b5cf6",
                                link: "/login"
                            },
                            {
                                icon: FaLaptop,
                                title: "Website  Maalum  ",
                                description: "Tunakupa tovuti ya kipekee kwa ajili ya shughuli yako.",
                                color: "#8b5cf6",
                                link: "/login"
                            }
                        ].map((feature, index) => (
                            <Link to={feature.link} key={index} className="error-feature-card">
                                <div className="error-feature-icon" style={{ background: `${feature.color}15` }}>
                                    <feature.icon style={{ color: feature.color, fontSize: '1.8rem' }} />
                                </div>
                                <h3 className="error-feature-title">{feature.title}</h3>
                                <p className="error-feature-description">{feature.description}</p>
                                <span className="error-feature-link">
                                    Jifunze Zaidi <FaArrowRight className="ms-1" size={12} />
                                </span>
                            </Link>
                        ))}
                    </div>
                </div>

                {/* ===== QUICK LINKS - REGISTRATION STEPS ===== */}
                <div className="error-quick-links">
                    <div className="error-quick-links-inner">
                        <div className="error-quick-links-header">
                            <h3>Jisajili Haraka Katika Hatua 4</h3>
                            <div className="section-divider" style={{ margin: '0.5rem 0' }}></div>
                            <p className="error-quick-links-subtitle">
                                Jisajili kwa urahisi na uanze kupanga shughuli yako ndani ya dakika chache
                            </p>
                        </div>
                        <div className="error-registration-steps">
                            <div className="registration-step">
                                <div className="step-number">1</div>
                                <div className="step-content">
                                    <div className="step-icon">
                                        <FaUserPlus />
                                    </div>
                                    <div className="step-info">
                                        <h4>Jina na Namba Ya Simu</h4>
                                        <p>Ingiza jina na namba ya simu</p>
                                    </div>
                                    <div className="step-arrow">
                                        <FaArrowRight />
                                    </div>
                                </div>
                            </div>

                            <div className="registration-step">
                                <div className="step-number">2</div>
                                <div className="step-content">
                                    <div className="step-icon">
                                        <FaCheckCircle />
                                    </div>
                                    <div className="step-info">
                                        <h4>Thibitisha OTP</h4>
                                        <p>Pokea message ya uhakiki wa OTP </p>
                                    </div>
                                    <div className="step-arrow">
                                        <FaArrowRight />
                                    </div>
                                </div>
                            </div>

                            <div className="registration-step">
                                <div className="step-number">3</div>
                                <div className="step-content">
                                    <div className="step-icon">
                                        <FaEnvelopeOpenText />
                                    </div>
                                    <div className="step-info">
                                        <h4>Password & Tarehe ya Shughuli</h4>
                                        <p>Weka password na tarehe ya shughuli</p>
                                    </div>
                                    <div className="step-arrow">
                                        <FaArrowRight />
                                    </div>
                                </div>
                            </div>

                            <div className="registration-step">
                                <div className="step-number">4</div>
                                <div className="step-content">
                                    <div className="step-icon">
                                        <FaHome />
                                    </div>
                                    <div className="step-info">
                                        <h4>Anza Kupanga</h4>
                                        <p>Uko tayari! Anza kupanga shughuli yako mara moja</p>
                                    </div>
                                    <div className="step-arrow final">
                                        <Link to="/login" className="step-start-btn">
                                            Anza Sasa
                                            <FaArrowRight className="ms-2" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="registration-cta">
                            <Link to="/login" className="registration-cta-btn">
                                Jisajili Bure Sasa
                                <FaArrowRight className="ms-2" />
                            </Link>
                            <span className="registration-cta-text">Hakuna malipo ya kujiunga</span>
                        </div>
                    </div>
                </div>

                {/* ===== CONTACT & SUPPORT ===== */}
                <div className="error-contact">
                    <div className="error-contact-inner">
                      
                        <h3>Bado Unatatizika?</h3>
                        <p>
                            Timu yetu iko tayari kukusaidia. Wasiliana nasi kwa njia zifuatazo:
                        </p>
                        <div className="error-contact-methods">
                            <a href="tel:+255747636516" className="error-contact-item">
                                <FaPhone />
                                <span>+255 747 636 516</span>
                            </a>
                            <a href="mailto:harusidotonline@gmail.com" className="error-contact-item">
                                <FaEnvelope />
                                <span> harusidotonline@gmail.com</span>
                            </a>
                            <a href="https://wa.me/255747636516" className="error-contact-item whatsapp">
                                <FaWhatsapp />
                                <span>WhatsApp</span>
                            </a>
                        </div>
                        <div className="error-social-links">
                            <a href="#" className="error-social-link"><FaFacebook /></a>
                            <a href="#" className="error-social-link"><FaInstagram /></a>
                            <a href="#" className="error-social-link"><FaWhatsapp /></a>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default Error404;